import { sizes } from '@bnnvara/breakpoints';

import resizeImageSource from './resizeImageSource';

/**
 * Returns an array of optimized image sources based on breakpoints.
 *
 * @param {*} source
 */
const getSourceSetValues = (source, ratio) => {
  if (!source.includes('{format}')) {
    return [];
  }

  return Object.values(sizes).map((width) => {
    const responsiveSource = resizeImageSource(source, width, ratio);
    return `${responsiveSource} ${width}w`;
  });
};

export default getSourceSetValues;
